<template>
  <div class="activeBox">
    <div class="activeMess">
      <div class="activeMessCheck">
        <p class="activeMessCheckTitle">活动列表</p>
        <div style="margin-top: 10px">
          <el-radio-group v-model="activityStatus" size="small" @change="getList">
            <el-radio-button label="PREPARE,COLLECT,EVALUATE,FINISHED" value="PREPARE,COLLECT,EVALUATE,FINISHED">全部</el-radio-button>
            <el-radio-button label="PREPARE" value="PREPARE">即将开始</el-radio-button>
            <el-radio-button label="COLLECT" value="COLLECT">征集中</el-radio-button>
            <el-radio-button label="EVALUATE" value="EVALUATE">评选中</el-radio-button>
            <el-radio-button label="FINISHED" value="FINISHED">已结束</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="activeList flex" v-loading="loading" v-if="activeList.length!=0">
        <div 
          class="activeListBox"
          v-for="(itemsList, index) in activeList"
          :key="index"
          @click="activeDetails(itemsList.uuid)"
        >
          <img :src="itemsList.activityLogo" alt="" />
          <div class="activeListBoxMess">
            <p>{{ itemsList.activityName }}</p>
            <span>{{ getNodeInfo(itemsList) }}</span>
            <div
              class="activeType"
              :class="
                itemsList.status == 'DRAFT' || itemsList.status == 'PREPARE'
                  ? 'activeTypeBlue'
                  : itemsList.status == 'COLLECT'
                  ? 'activeTypeYellow'
                  : itemsList.status == 'EVALUATE'
                  ? 'activeTypeGreen'
                  : itemsList.status == 'FINISHED'
                  ? ''
                  : ''
              "
            >
              {{ itemsList.status == 'DRAFT'||itemsList.status == 'PREPARE'?'即将开始'
              :itemsList.status == 'COLLECT'?dateInfo(itemsList,1):itemsList.status == 'EVALUATE'?'评选中':'已结束' }}
            </div>
          </div>
          <div class="activeListBoxMessSee">
            <div class="activeIcon">
              <i class="el-icon-view"></i>
              <p>{{ itemsList.volume }}</p>
            </div>
            <div class="activeIcon">
              <i class="iconfont">&#xe604;</i>
              <p>{{ itemsList.worksCount }}</p>
            </div>
            <div class="activeIcon">
              <i class="iconfont">&#xe6d6;</i>
              <p>{{ itemsList.signCount }}</p>
            </div>
          </div>
        </div>
      </div>
       <div class="list_box"  v-loading="loading" v-else>
            <img src="../../../assets/暂无内容.jpg" alt="">

      </div>
      <div style="text-align: right">
        <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total" class="pagination">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityList } from '../../../utils/interface';
export default {
  name: "activelist",
  data() {
    return {
      activityStatus:"PREPARE,COLLECT,EVALUATE,FINISHED",
      activeList: [],
      loading: false,
      current:0,
      pageSize:10,
      total:0,
    };
  },
  created(){
    this.getList();
  },
  methods: {
    getList(){
      this.loading = true;
      let params = {
        statusStr:this.activityStatus,
        current:this.current,
        pageSize:this.pageSize
      };
      getActivityList(params).then((res)=>{
        this.activeList = res.list;
        this.total = res.total;
        this.loading = false
      });
    },
    getDate(value){
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "年" + MM + "月" + d + "日";
    },
    // 计算时间
    dateInfo(item,index){
      //date1结束时间
      //let date1 = new Date(val);
      let startDate = new Date();
      let endDate = new Date();
      if(item.nodeList.length > 0){
        for(let i=0;i<item.nodeList.length;i++){
          if(item.nodeList[i].status==="COLLECT"&&item.nodeList[i].dateType==="RANGE") {
            startDate = new Date(item.nodeList[i].startDate);
            endDate = new Date(item.nodeList[i].endDate);
            break;
          }else if(item.nodeList[i].status==="COLLECT"&&item.nodeList[i].dateType==="DATE"){
            startDate = new Date(item.nodeList[i].startDate);
            console.log(startDate);
            for(let k=0;k<item.nodeList.length;k++){
              if(item.nodeList[k].sort>item.nodeList[i].sort){
                endDate = new Date(item.nodeList[k].startDate);
                break;
              }
            }
            break;
          }
        }
      }
      //date2当前时间
      let date2 = new Date();
      //date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
      date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
      endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
      const diff = endDate.getTime() - date2.getTime(); //目标时间减去当前时间
      if(index==1){
          if(diff>=0){
              return "距离征集结束还有"+(diff / (24 * 60 * 60 * 1000)+1)+"天";  //计算当前时间与结束时间之间相差天数
          }else{
              return "征集结束";
          }
      }
    },
    // 进详情
    activeDetails(uuid){
      sessionStorage.setItem('activeDetailsNums','00');
      let routeData = this.$router.resolve({
          name: "activeDetail",
          params: { uuid: uuid }
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "activeDetail", params: { uuid: uuid } });
    },
    getNodeInfo(item){
      if(item.nodeList.length > 0){
        for(let i=0;i<item.nodeList.length;i++){
          if(item.nodeList[i].status==="COLLECT"&&item.nodeList[i].dateType==="RANGE"){
            return this.getDate(item.nodeList[i].startDate)+"——"+this.getDate(item.nodeList[i].endDate);
            break;
          }else if(item.nodeList[i].status==="COLLECT"&&item.nodeList[i].dateType==="DATE"){
            for(let k=0;k<item.nodeList.length;k++){
              if(item.nodeList[k].sort>item.nodeList[i].sort){
                return this.getDate(item.nodeList[i].startDate)+"——"+this.getDate(item.nodeList[k].startDate);
                break;
              }
            }
            break;
          }
        }
      }
    },
    // 分页
    handleCurrentChange(val){
      this.current = val;
	  window.scrollTo(0,0);
      this.getList();
    },
  },
};
</script>

<style scoped lang="less">
.activeBox {
  background: #f9f9f9;
  padding: 31px 0 73px;
  .activeMess {
    width: 1200px;
    margin: 0 auto;
    .activeMessCheck {
      .activeMessCheckTitle {
        font-size: 18px;
        font-weight: bold;
        color: #157efb;
      }
    }
  }
   .list_box{
     text-align: center;
      img{
        width: 200px;
        text-align: center;
      }
    }
  .activeList {
    align-items: center;
    justify-content: space-between;
    margin-top: 25px;
    flex-wrap: wrap;
   
    .activeListBox {
      background: #fff;
      border-radius: 4px;
      flex-shrink: 0;
      width: 591px;
      margin-bottom: 20px;
      img {
        border-radius: 4px 4px 0 0;
        background: #efefef;
        width: 100%;
        height: 300px;
        cursor: pointer;
      }
      .activeListBoxMess {
        padding: 14px 15px;
        position: relative;
        p {
          font-size: 16px;
          margin-bottom: 10px;
          cursor: pointer;
        }
        span {
          font-size: 14px;
          color: #bebebe;
        }
        .activeType {
          position: absolute;
          right: 0;
          top: 23px;
          line-height: 29px;
          text-align: center;
          width: 162px;
          height: 29px;
          background-image: url('../../../assets/activelistImg/gray.jpg');
          color: #fff;
          font-size: 12px;
        }
        .activeTypeYellow {
          background-image: url('../../../assets/activelistImg/yellow.jpg');
        }
        .activeTypeGreen {
          background-image: url('../../../assets/activelistImg/green.jpg');
        }
        .activeTypeBlue {
          background-image: url('../../../assets/activelistImg/blue.jpg');
        }
      }
      .activeListBoxMessSee {
        border-top: 1px solid #cdcdcd;
        font-size: 12px;
        color: #157efb;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 18px;
        i {
          margin-right: 5px;
          font-size: 14px;
        }
        .activeIcon {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/activeList.vue